"use client";

import { cn } from "@/lib/utils";
import { Menu } from "../../../payload-types";
import { useTranslations } from "next-intl";
import Image from "next/image";
import AllergensDesktop from "./allergens-desktop";
import AllergensMobile from "./allergens-mobile";
import { typographyClass } from "../typography";

export type AllergensProps = {
  allergens?: NonNullable<
    NonNullable<
      NonNullable<Menu["dishGroup"]>[number]["category"]
    >[number]["dishes"]
  >[number]["allergens"];
  className?: string;
  isMobile: boolean;
};

export default function Allergens({
  allergens,
  className,
  isMobile,
}: AllergensProps) {
  const t = useTranslations("menu");
  const trigger = (
    <div className={cn(className, "flex gap-1 w-fit")}>
      {allergens?.map((allergen, allergenIndex) => {
        return (
          <span key={`dish-${allergenIndex}`}>
            <Image
              src={`/allergens/${allergen}.svg`}
              width={20}
              height={20}
              alt={t(allergen)}
            />
          </span>
        );
      })}
    </div>
  );
  const content = (
    <div className="!bg-background flex flex-col border shadow-sm !px-4 !py-2 rounded-md">
      <span
        className={cn(typographyClass.body, "font-semibold mb-2 text-black")}
      >
        {t("allergens")}
      </span>
      {allergens?.map((allergen, allergenIndex) => {
        return (
          <div
            className="p-1 flex gap-2 items-center"
            key={`dish-${allergenIndex}-text`}
          >
            <Image
              src={`/allergens/${allergen}.svg`}
              width={22}
              height={22}
              alt={t(allergen)}
            />
            <span className={cn(typographyClass.body, "text-black")}>
              {t(allergen)}
            </span>
          </div>
        );
      })}
    </div>
  );
  return isMobile ? (
    <AllergensMobile trigger={trigger} content={content} />
  ) : (
    <AllergensDesktop trigger={trigger} content={content} />
  );
}
